var map = {
	"./BOU/matrix.png": "e36d",
	"./DRU/matrix.png": "3bb5",
	"./FNB/matrix.png": "0686",
	"./HIM/matrix.png": "21c5",
	"./OTH/matrix.png": "a979",
	"./SUP/matrix.png": "13e8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bf37";